import * as React from "react"
import { SVGProps } from "react"

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M.5 3.85 6.65 10a.48.48 0 0 0 .7 0l6.15-6.15" />
  </svg>
)
export default SvgArrowDown
